import { FC } from 'react';
import { ReactKit } from '@team/react';
import { Tappable } from '../../../../services/tappable';
import { Caption } from '../../../../typography/caption';
import { ItemBasicProps } from '../../types';
import css from './style.module.css';

export const Basic: FC<ItemBasicProps> = ({
  Component = 'button',
  children,
  label,
  selected = false,
  disabled = false,
  indicator,
  rootRef,
  ...props
}) => (
  <Tappable
    {...props}
    Component={Component}
    baseClassName={css.root}
    hoverMode="opacity"
    activeMode="opacity"
    activeEffectDelay={70}
    aria-selected={selected}
    disabled={disabled}
    ref={rootRef}
  >
    <span className={css.icon}>
      {children}

      {ReactKit.hasNode(indicator) && (
        <span className={css.indicator}>{indicator}</span>
      )}
    </span>

    <Caption level={2} weight={2}>
      {label}
    </Caption>
  </Tappable>
);
